import React from 'react';
import { createUseStyles } from 'react-jss';
import Headline from '../../elements/Headline';
import IconButton from '../../elements/IconButton';
import { Close } from '../../assets/vectors';
import theme from '../../constants/Theme';

interface DialogHeaderProps {
  title: string;
  headlineSize?: number;
  onClose?: () => void;
}

const DialogHeader = ({ title, headlineSize = 20, onClose }: DialogHeaderProps) => {
  const classes = useStyles();

  return (
    <div className={classes.headerContainer}>
      <div className={classes.header}>
        <Headline fontSize={headlineSize} marginBottom={0}>
          {title}
        </Headline>
        {onClose && (
          <div className={classes.closeButtonContainer}>
            <IconButton icon={Close} size={24} onClick={onClose} />
          </div>
        )}
      </div>
      <div className={classes.divider} />
    </div>
  );
};

const useStyles = createUseStyles({
  headerContainer: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  header: {
    paddingBottom: 8,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    height: 1,
    backgroundColor: theme.colors.blueLight,
    width: '100%',
  },
});

export default DialogHeader;
